export const SET_PLAN = "SET_PLAN";

export const setPlanAct = (plan) => {
  console.log("plandfsdf", plan)
  return {
    type: SET_PLAN,
    payload: plan,
  }
};
